import { OnlineBankVerificationVB } from 'pages/index';
import { ROUTES } from 'utils/constants/constants_routes';
import { useLocation } from 'react-router-dom';
import { useOnlineBankVerification } from 'pages/OnlineBank/OnlineBankVerification/useOnlineBankVerification';
import OnlineBankVerificationVA from './OnlineBankVerificationVA/OnlineBankVerificationVA';
import TinkCloseModal from 'pages/OnlineBank/OnlineBankVerification/components/TinkCloseModal/TinkCloseModal';
import TinkCredentialsFailedModal from 'pages/OnlineBank/OnlineBankVerification/components/TinkCredentialsFailedModal/TinkCredentialsFailedModal';

export type OnlineBankVerificationContextType = ReturnType<
  typeof useOnlineBankVerification
>;

const OnlineBankVerification = () => {
  const verification = useOnlineBankVerification();
  const { pathname } = useLocation();

  const {
    isTinkCloseModalOpen,
    isTinkCredentialsFailedModalOpen,
    setIsTinkCredentialsFailedModalOpen,
    onRetryTink,
  } = verification;

  const OnlineBankVerifyVersion =
    pathname === ROUTES.FIRST_LOAN_ONLINE_BANK_VERIFY
      ? OnlineBankVerificationVA
      : OnlineBankVerificationVB;

  return (
    <>
      <TinkCloseModal isOpen={isTinkCloseModalOpen} onRetry={onRetryTink} />
      <TinkCredentialsFailedModal
        isOpen={isTinkCredentialsFailedModalOpen}
        onClose={() => setIsTinkCredentialsFailedModalOpen(false)}
      />
      <OnlineBankVerifyVersion context={verification} />
    </>
  );
};

export default OnlineBankVerification;
